

















































import { List, Toast, Dialog, Image } from "vant";
import { Component, Vue,Prop, Watch  } from "vue-property-decorator";
import LinkAccount from "@/views/h5-page/account/Component/LinkAccount.vue";
import AccountDetail from "@/views/h5-page/account/Component/AccuntDetail.vue";
export const EventBus = new Vue();
//   import { ocrIdCard } from "@/apis";


@Component({
  name: "AccountList",
  components: {
    AccountDetail,
    LinkAccount,
    [List.name]: List,
    [Dialog.Component.name]: Dialog.Component,
    [Image.name]: Image
  },

})


export default class AccountList extends Vue {


  @Prop({
    type: Boolean,
    default: false
  })
  private refresh;

  @Watch("refresh")
  watchValue(newVal){
    this.getAccountList();
    
  }

  active = 0;
  list: any = [];
  loading = false;
  finished = true;
  showLinkAccount = false;
  showAccountDetail = false;
  newResult = {};
  accountDetail = {};
  tradeAccount: any = [];
  // 创建事件总线实例



  onLinkAccountClose() {
    (this as any).$emit("close");
    this.showLinkAccount = false;
  }

  onAccountDetailClose(refresh) {
    this.showAccountDetail = false;
    if (refresh) {
      this.getAccountList();
    }
  }


  successs() {
    this.getAccountList();
  }

  addGroupSuccess() {
    (this as any).$emit("success");
  }


  onShowLink(result) {
    this.newResult = result;
    this.showLinkAccount = true;
  }

  onConnect(id) {
    this.showLinkAccount = true;
  }

  computed() {

  }

  //删除账户
  onDel(id) {
    
	Toast.resetDefaultOptions();
    Dialog.confirm({
      title: "删除账户",
      message: "确定删除吗？"
    })
      .then(() => {
        const data = { id: id };
        (this as any).$apis.accountDel(data)
          .then(res => {
            Toast("删除成功");
            setTimeout(() => {
              (this as any).$emit("success");
            }, 500);

          })
          .catch(e => {
            
          });
      })
      .catch(() => {
        // on cancel
      });


  }


  getAccountList() {
    (this as any).$apis.accountList()
      .then(res => {
        this.list = res.data;
        
        const { key, img } = res;
      })
      .catch(e => {
        
      });
  }

  getAccountTradeList(account) {
    (this as any).accountDetail = account;
    const param = { id: account.id };
    (this as any).$apis
      .accountTradeList(param)
      .then(res => {
        (this as any).tradeAccount = res;
        (this as any).showAccountDetail = true;
        
      })
      .catch(e => {
        
      });
  }

  onload() {

  }



  created() {
    Toast.resetDefaultOptions();
    this.getAccountList();
  }



};
